module.exports = "<!DOCTYPE html>\n<html lang=\"en\">\n\n<head>\n    <meta charset=\"UTF-8\">\n    <meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">\n    <meta http-equiv=\"X-UA-Compatible\" content=\"ie=edge\">\n    <title>Document</title>\n</head>\n\n<body>\n    <div class=\"container\">\n        <app-page-header></app-page-header>\n        <app-feature></app-feature>\n        <app-show-book></app-show-book>\n    </div>\n</body>\n\n</html>"


//////////////////
// WEBPACK FOOTER
// C:/Users/yanir/Desktop/workspace/TheBooksLibrary/src/app/components/home/home.component.html
// module id = ../../../../../src/app/components/home/home.component.html
// module chunks = main